(function () {
const CONFIG = {
  daysPerMonth: 30,
  insertCostAfterItemIndex: 0,
  costLabelPrefix: "That's just ",
  costBoldSuffix: "/day",
  costLabelSuffix: " for my skin routine",
  benefitsTextColor: "#6C6660",
  costTextColor: "#000000",
  fontSize: "16px",
  dotSize: "16px",
  gap: "14px",
  oneTimeCostLabelPrefix: "That's just ",
  oneTimeCostBoldSuffix: "/day",
  oneTimeCostLabelSuffix: " try it once, risk free",

  defaultPlanTextMatch: "every 2 month",
};

  let renderTimer = null;
  const observedRoots = new WeakSet();

function getActiveCurrencyCode() {
  const shopifyCurrency = window.Shopify?.currency?.active;

  if (shopifyCurrency) {
    return String(shopifyCurrency).toUpperCase();
  }

  const configCurrency = window.SubscriptionWidgetConfig?.shop?.currency;

  if (configCurrency) {
    return String(configCurrency).toUpperCase();
  }

  const analyticsCurrency = window.ShopifyAnalytics?.meta?.currency;

  return analyticsCurrency ? String(analyticsCurrency).toUpperCase() : "";
}

function getCurrencyFractionDigits(currencyCode) {
  if (!currencyCode) return 2;

  try {
    return new Intl.NumberFormat("en", {
      style: "currency",
      currency: currencyCode,
    }).resolvedOptions().maximumFractionDigits;
  } catch (error) {
    return 2;
  }
}

function getCurrencySymbolFromPage(currencyCode) {
  const contextElement = document.querySelector(
    "[data-custom-comp-money-context]"
  );

  if (!contextElement) return "";

  try {
    const context = JSON.parse(contextElement.textContent || "{}");
    const contextCode = String(context.currencyCode || "").toUpperCase();

    return contextCode === currencyCode ? context.currencySymbol || "" : "";
  } catch (error) {
    return "";
  }
}

function formatCurrency(value, currencyCode = getActiveCurrencyCode()) {
  if (!Number.isFinite(value)) return "";

  if (!currencyCode) {
    return value.toFixed(2);
  }

  try {
    const formatter = new Intl.NumberFormat(
      document.documentElement.lang || "en",
      {
        style: "currency",
        currency: currencyCode,
        currencyDisplay: "narrowSymbol",
      }
    );
    const parts = formatter.formatToParts(value);
    const currencyPart = parts.find((part) => part.type === "currency");
    const currencySymbol =
      getCurrencySymbolFromPage(currencyCode) ||
      (currencyPart ? currencyPart.value : "");
    const amount = parts
      .filter((part) => part.type !== "currency" && part.type !== "literal")
      .map((part) => part.value)
      .join("");

    if (!currencySymbol) {
      return `${currencyCode} ${amount}`;
    }

    const separator = currencySymbol === currencyCode ? " " : "";

    return `${currencySymbol}${separator}${amount}`;
  } catch (error) {
    return `${currencyCode} ${value.toFixed(2)}`;
  }
}

function ensureCurrencyFontFallback() {
  deepQueryAll(".rc-custom-cost-bold, .rc-custom-onetime-cost-bold").forEach(
    (element) => {
      element.style.setProperty(
        "font-family",
        "Arial, sans-serif",
        "important"
      );
    }
  );
}

function scheduleRender() {
  clearTimeout(renderTimer);
  renderTimer = setTimeout(function () {
    renderRechargeCostPerDay();
    ensureCurrencyFontFallback();
  }, 0);
}

function selectDefaultTwoMonthPlan() {
  if (isSelectedVariantSoldOut()) {
    return;
  }

  const subscriptionCard = getSubscriptionCard();

  if (!subscriptionCard) {
    return;
  }

  const root = subscriptionCard.getRootNode();
  const customCard = root.querySelector(".rc-custom-selling-plans-card");
  const sellingPlans = getSellingPlansElement(subscriptionCard, customCard);

  if (!sellingPlans || !sellingPlans.shadowRoot) {
    return;
  }

  // Prevent forcing the default again after the customer manually changes it.
  if (sellingPlans.dataset.rcCustomDefaultPlanApplied === "true") {
    return;
  }

  const sellingPlansRoot = sellingPlans.shadowRoot;

  const labels = Array.from(
    sellingPlansRoot.querySelectorAll('label[part~="rc-plans-radio-button"]')
  );

  const targetLabel = labels.find((label) => {
    const intervalText = label
      .querySelector(".rc-plans-button__interval")
      ?.textContent
      ?.trim()
      ?.toLowerCase();

    return intervalText && intervalText.includes(CONFIG.defaultPlanTextMatch);
  });

  if (!targetLabel) {
    return;
  }

  const input = targetLabel.querySelector('input[type="radio"]');

  if (!input) {
    return;
  }

  sellingPlans.dataset.rcCustomDefaultPlanApplied = "true";

  if (!input.checked) {
    input.click();

    input.dispatchEvent(
      new Event("input", {
        bubbles: true,
        composed: true,
      })
    );

    input.dispatchEvent(
      new Event("change", {
        bubbles: true,
        composed: true,
      })
    );
  }
}

function parsePrice(priceText, currencyCode = getActiveCurrencyCode()) {
  if (!priceText) return null;

  const matches = String(priceText).match(/\d[\d\s.,'’]*/g);

  if (!matches || !matches.length) {
    return null;
  }

  const rawPrice = matches[matches.length - 1]
    .trim()
    .replace(/[\s'’]/g, "");
  const fractionDigits = getCurrencyFractionDigits(currencyCode);

  if (fractionDigits === 0) {
    const value = Number.parseInt(rawPrice.replace(/[.,]/g, ""), 10);
    return Number.isFinite(value) ? value : null;
  }

  const lastComma = rawPrice.lastIndexOf(",");
  const lastDot = rawPrice.lastIndexOf(".");
  const decimalIndex = Math.max(lastComma, lastDot);
  const digitsAfterSeparator =
    decimalIndex > -1 ? rawPrice.length - decimalIndex - 1 : 0;
  const separatorCount = (rawPrice.match(/[.,]/g) || []).length;
  const hasDecimalSeparator =
    decimalIndex > -1 &&
    digitsAfterSeparator > 0 &&
    digitsAfterSeparator <= fractionDigits &&
    (lastComma > -1 && lastDot > -1 || separatorCount === 1);
  let normalized;

  if (hasDecimalSeparator) {
    normalized =
      rawPrice.slice(0, decimalIndex).replace(/[.,]/g, "") +
      "." +
      rawPrice.slice(decimalIndex + 1);
  } else {
    normalized = rawPrice.replace(/[.,]/g, "");
  }

  const value = Number.parseFloat(normalized);

  return Number.isFinite(value) ? value : null;
}

function getVisibleText(element) {
  const clone = element.cloneNode(true);

  clone.querySelectorAll(".visually-hidden").forEach((hiddenElement) => {
    hiddenElement.remove();
  });

  return clone.textContent.trim();
}

  function parseIntervalDays(intervalText) {
    if (!intervalText) return CONFIG.daysPerMonth;

    const text = intervalText.toLowerCase();

    const dayMatch = text.match(/every\s+(\d+)\s+day/);
    if (dayMatch) return Number(dayMatch[1]);

    const weekMatch = text.match(/every\s+(\d+)\s+week/);
    if (weekMatch) return Number(weekMatch[1]) * 7;

    const monthMatch = text.match(/every\s+(\d+)\s+month/);
    if (monthMatch) return Number(monthMatch[1]) * CONFIG.daysPerMonth;

    const yearMatch = text.match(/every\s+(\d+)\s+year/);
    if (yearMatch) return Number(yearMatch[1]) * 365;

    return CONFIG.daysPerMonth;
  }

  function formatDailyPrice(value) {
    return formatCurrency(value);
  }

  function getSelectedSubscriptionCard() {
    const cards = deepQueryAll('[part~="rc-purchase-option__subscription"]');

    return cards.find((card) => {
      const part = card.getAttribute("part") || "";
      return part.includes("rc-purchase-option__selected") || card.hasAttribute("rc-selected");
    });
  }

  function getOneTimeCard() {
  const purchaseOptions = deepQueryAll('[part~="rc-purchase-option"]');

  return purchaseOptions.find((option) => {
    const part = option.getAttribute("part") || "";
    const text = option.textContent.toLowerCase();

    return (
      part.includes("onetime") ||
      part.includes("one-time") ||
      part.includes("one_time") ||
      text.includes("one time") ||
      text.includes("one-time") ||
      option.querySelector('input[name="purchaseOption"][value*="onetime" i]') ||
      option.querySelector('input[name="purchaseOption"][value*="one-time" i]')
    );
  }) || null;
}

function getOneTimePriceElement(oneTimeCard) {
  if (!oneTimeCard) return null;

  return (
    oneTimeCard.querySelector('[part~="rc-purchase-option__price"]') ||
    oneTimeCard.querySelector('[part~="rc-purchase-option__discounted-price"]') ||
    oneTimeCard.querySelector('[part~="rc-purchase-option__original-price"]')
  );
}

function renderOneTimeCostPerDayRow(oneTimeCard, costData) {
  if (!oneTimeCard) return;

  const container =
    oneTimeCard.querySelector('[part~="rc-purchase-option__sub-container"]') ||
    oneTimeCard;

  let existingRow = container.querySelector(".rc-custom-onetime-cost-per-day-row");

  if (existingRow && existingRow.dataset.costText === costData.fullText) {
    return;
  }

  if (existingRow) {
    existingRow.remove();
  }

  const costRow = document.createElement("div");
  costRow.className = "rc-custom-onetime-cost-per-day-row";
  costRow.dataset.costText = costData.fullText;

  costRow.style.marginTop = "4px";
  costRow.style.color = CONFIG.costTextColor || "#000000";
  costRow.style.fontSize = CONFIG.fontSize;
  costRow.style.fontWeight = "400";
  costRow.style.lineHeight = "1.4";

  const costTextElement = document.createElement("span");
  costTextElement.className = "rc-custom-onetime-cost-per-day-text";

  const prefixSpan = document.createElement("span");
  prefixSpan.className = "rc-custom-onetime-cost-prefix";
  prefixSpan.textContent = costData.prefix;

  const boldSpan = document.createElement("span");
  boldSpan.className = "rc-custom-onetime-cost-bold";
  boldSpan.textContent = `${costData.price}${costData.boldSuffix}`;
  boldSpan.style.fontWeight = "700";

  const suffixSpan = document.createElement("span");
  suffixSpan.className = "rc-custom-onetime-cost-suffix";
  suffixSpan.textContent = costData.suffix;

  costTextElement.appendChild(prefixSpan);
  costTextElement.appendChild(boldSpan);
  costTextElement.appendChild(suffixSpan);

  costRow.appendChild(costTextElement);
  container.appendChild(costRow);
}

function renderOneTimeCostPerDayComparison(intervalDays) {
  const oneTimeCard = getOneTimeCard();

  if (!oneTimeCard || !intervalDays) {
    return;
  }

  const oneTimePriceElement = getOneTimePriceElement(oneTimeCard);

  if (!oneTimePriceElement) {
    return;
  }

  const oneTimePriceText = getVisibleText(oneTimePriceElement);
  const oneTimePrice = parsePrice(oneTimePriceText);

  if (oneTimePrice === null) {
    return;
  }

  const dailyPrice = oneTimePrice / intervalDays;
  const formattedDailyPrice = formatDailyPrice(dailyPrice);

  const costData = {
    fullText: `${CONFIG.oneTimeCostLabelPrefix}${formattedDailyPrice}${CONFIG.oneTimeCostBoldSuffix}${CONFIG.oneTimeCostLabelSuffix}`,
    prefix: CONFIG.oneTimeCostLabelPrefix,
    price: formattedDailyPrice,
    boldSuffix: CONFIG.oneTimeCostBoldSuffix,
    suffix: CONFIG.oneTimeCostLabelSuffix,
  };

  renderOneTimeCostPerDayRow(oneTimeCard, costData);
}

function getSelectedPlanText(subscriptionCard) {
  const root = subscriptionCard.getRootNode();
  const customCard = root.querySelector(".rc-custom-selling-plans-card");
  const sellingPlans = getSellingPlansElement(subscriptionCard, customCard);

  if (!sellingPlans || !sellingPlans.shadowRoot) {
    return "";
  }

  const selectedInterval = sellingPlans.shadowRoot.querySelector(
    '[part~="rc-plans-button__selected"] [part~="rc-plans-button__interval"], [data-checked] [part~="rc-plans-button__interval"]'
  );

  return selectedInterval ? selectedInterval.textContent.trim() : "";
}

  function getBenefitsList(subscriptionCard) {
    const benefits = subscriptionCard.querySelector("rc-benefits");

    if (!benefits || !benefits.shadowRoot) {
      return null;
    }

    return benefits.shadowRoot.querySelector('[part~="rc-benefits__list"]');
  }

  function getBenefitTexts(benefitsList) {
    return Array.from(benefitsList.querySelectorAll("li, p"))
      .map((item) => item.textContent.trim())
      .filter(Boolean);
  }

  function createBenefitItem(text) {
    const item = document.createElement("span");
    item.className = "rc-custom-benefit-item";

    item.style.display = "inline-flex";
    item.style.alignItems = "baseline";
    item.style.gap = "5px";
    item.style.whiteSpace = "nowrap";
    item.style.color = CONFIG.benefitsTextColor;
    item.style.fontSize = CONFIG.fontSize;
    item.style.fontWeight = "400";
    item.style.lineHeight = "1.6";

    const dot = document.createElement("span");
    dot.textContent = "∙";
    dot.style.fontSize = CONFIG.dotSize;
    dot.style.lineHeight = "1";
    dot.style.color = CONFIG.benefitsTextColor;

    const label = document.createElement("span");
    label.textContent = text;

    item.appendChild(dot);
    item.appendChild(label);

    return item;
  }

function renderCustomBenefitsRow(benefitsList, benefitTexts) {
  const existingRow = benefitsList.parentNode.querySelector(".rc-custom-benefits-row");

  const signature = benefitTexts.join("|");

  if (existingRow && existingRow.dataset.signature === signature) {
    return existingRow;
  }

  if (existingRow) {
    existingRow.remove();
  }

  benefitsList.style.display = "none";

  const row = document.createElement("div");
  row.className = "rc-custom-benefits-row";
  row.dataset.signature = signature;

  row.style.display = "flex";
  row.style.flexWrap = "wrap";
  row.style.alignItems = "center";
  row.style.columnGap = CONFIG.gap;
  row.style.rowGap = "2px";
  row.style.margin = "0";
  row.style.padding = "0";

  benefitTexts.forEach((text) => {
    row.appendChild(createBenefitItem(text));
  });

  benefitsList.after(row);

  return row;
}

function renderCostPerDayRow(benefitsList, costData) {
  const parent = benefitsList.parentNode;

  let existingRow = parent.querySelector(".rc-custom-cost-per-day-row");

  if (existingRow && existingRow.dataset.costText === costData.fullText) {
    return;
  }

  if (existingRow) {
    existingRow.remove();
  }

  const costRow = document.createElement("div");
  costRow.className = "rc-custom-cost-per-day-row";
  costRow.dataset.costText = costData.fullText;

  costRow.style.marginTop = "4px";
  costRow.style.color = CONFIG.costTextColor;
  costRow.style.fontSize = CONFIG.fontSize;
  costRow.style.fontWeight = "400";
  costRow.style.lineHeight = "1.4";

  const costTextElement = document.createElement("span");
  costTextElement.className = "rc-custom-cost-per-day-text";

  const prefixSpan = document.createElement("span");
  prefixSpan.className = "rc-custom-cost-prefix";
  prefixSpan.textContent = costData.prefix;

  const boldSpan = document.createElement("span");
  boldSpan.className = "rc-custom-cost-bold";
  boldSpan.textContent = `${costData.price}${costData.boldSuffix}`;
  boldSpan.style.fontWeight = "700";

  const suffixSpan = document.createElement("span");
  suffixSpan.className = "rc-custom-cost-suffix";
  suffixSpan.textContent = costData.suffix;

  costTextElement.appendChild(prefixSpan);
  costTextElement.appendChild(boldSpan);
  costTextElement.appendChild(suffixSpan);

  costRow.appendChild(costTextElement);

  const benefitsRow = parent.querySelector(".rc-custom-benefits-row");

  if (benefitsRow) {
    benefitsRow.after(costRow);
  } else {
    benefitsList.after(costRow);
  }
}

function isSubscriptionCardSelected(subscriptionCard) {
  if (!subscriptionCard) return false;

  const part = subscriptionCard.getAttribute("part") || "";

  return (
    part.includes("rc-purchase-option__selected") ||
    subscriptionCard.hasAttribute("rc-selected")
  );
}

function getProductJsonFromPage() {
  const scripts = document.querySelectorAll('script[type="application/json"]');

  for (const script of scripts) {
    try {
      const data = JSON.parse(script.textContent || "");

      if (data && Array.isArray(data.variants) && data.variants.length && data.title) {
        return data;
      }
    } catch (error) {
      // Ignore unrelated JSON blobs.
    }
  }

  return null;
}

function getSelectedVariantFromPage() {
  const product = getProductJsonFromPage();

  if (!product) {
    return null;
  }

  const idInput = document.querySelector(
    '#add-to-cart-form [name="id"], form[action*="/cart/add"] [name="id"]'
  );

  if (idInput) {
    const selectedId =
      idInput.value ||
      (idInput.options && idInput.options[idInput.selectedIndex]
        ? idInput.options[idInput.selectedIndex].value
        : "");

    if (selectedId) {
      const byId = product.variants.find(function (variant) {
        return String(variant.id) === String(selectedId);
      });

      if (byId) {
        return byId;
      }
    }
  }

  const selectedOptions = Array.from(
    document.querySelectorAll("#add-to-cart-form .swatch input:checked")
  ).map(function (input) {
    return input.value;
  });

  if (selectedOptions.length) {
    const byOptions = product.variants.find(function (variant) {
      return selectedOptions.every(function (optionValue, index) {
        return (
          String(variant.options?.[index] || variant["option" + (index + 1)] || "") ===
          String(optionValue)
        );
      });
    });

    if (byOptions) {
      return byOptions;
    }
  }

  const urlVariantId = new URLSearchParams(window.location.search).get("variant");

  if (urlVariantId) {
    return (
      product.variants.find(function (variant) {
        return String(variant.id) === String(urlVariantId);
      }) || null
    );
  }

  return (
    product.variants.find(function (variant) {
      return variant.available;
    }) ||
    product.variants[0] ||
    null
  );
}

function isSelectedVariantSoldOut() {
  const variant = getSelectedVariantFromPage();

  if (variant) {
    return variant.available === false;
  }

  const purchaseButton = document.querySelector("#purchase, [name='add']");

  if (purchaseButton && purchaseButton.disabled) {
    const label = (purchaseButton.textContent || "").toLowerCase();
    return label.includes("sold out") || label.includes("unavailable");
  }

  return false;
}

function selectOneTimePurchaseOption() {
  const onetimeInput =
    deepQueryAll(
      '[part~="rc-purchase-option__onetime"] input[type="radio"], input.rc-purchase-option__input[value="onetime"]'
    )[0] || null;

  if (onetimeInput && !onetimeInput.checked) {
    onetimeInput.click();
  }
}

function syncSoldOutFrequencyVisibility() {
  const soldOut = isSelectedVariantSoldOut();
  const subscriptionCard = getSubscriptionCard();
  const widget =
    deepQueryAll("recharge-subscription-widget")[0] ||
    document.querySelector("recharge-subscription-widget");

  document.documentElement.classList.toggle("rc-variant-soldout", soldOut);

  if (widget) {
    widget.classList.toggle("rc-variant-soldout", soldOut);
    widget.toggleAttribute("data-variant-soldout", soldOut);
  }

  if (!subscriptionCard) {
    return soldOut;
  }

  const root = subscriptionCard.getRootNode();
  const customCard = root.querySelector(".rc-custom-selling-plans-card");

  if (customCard) {
    if (soldOut) {
      customCard.hidden = true;
      customCard.setAttribute("data-hidden-soldout", "true");
    } else if (customCard.getAttribute("data-hidden-soldout") === "true") {
      customCard.removeAttribute("data-hidden-soldout");
    }
  }

  if (soldOut) {
    selectOneTimePurchaseOption();
  }

  return soldOut;
}

function getSubscriptionCard() {
  return deepQueryAll('[part~="rc-purchase-option__subscription"]')[0] || null;
}

function getSellingPlansElement(subscriptionCard, customCard) {
  if (!subscriptionCard) return null;

  // 1. Prefer the fresh Recharge-generated selector inside the subscription card.
  // This is usually the one that still controls price correctly after Recharge re-renders.
  const freshSellingPlans = subscriptionCard.querySelector("rc-selling-plans");

  if (freshSellingPlans) {
    return freshSellingPlans;
  }

  // 2. If Recharge has not recreated it, use the one we already moved.
  if (customCard) {
    const movedSellingPlans = customCard.querySelector("rc-selling-plans");

    if (movedSellingPlans) {
      return movedSellingPlans;
    }
  }

  return null;
}

function removeDuplicateSellingPlans(customCard, sellingPlansToKeep) {
  if (!customCard) return;

  const allSellingPlans = Array.from(customCard.querySelectorAll("rc-selling-plans"));

  allSellingPlans.forEach((sellingPlans) => {
    if (sellingPlans !== sellingPlansToKeep) {
      sellingPlans.remove();
    }
  });
}

function ensureCustomSellingPlansStyles(root) {
  if (root.querySelector("#rc-custom-selling-plans-styles")) {
    return;
  }

  const style = document.createElement("style");
  style.id = "rc-custom-selling-plans-styles";

  style.textContent = `
    /*
      Hide freshly recreated Recharge interval selectors by default.
      JS will add .rc-custom-selling-plans-mounted only after moving the
      real selector into the custom card.
    */
    rc-selling-plans:not(.rc-custom-selling-plans-mounted) {
      display: none !important;
    }

    rc-radio-icon[checked] {
  --rc-widget-brand-color: #720111 !important;
}

    .rc-custom-selling-plans-card {
      margin-top: 0;
      margin-bottom: 10px;
      padding-top: 0;
      background: #ffffff;
    }

    .rc-custom-selling-plans-card[hidden] {
      display: none !important;
    }

    .rc-custom-selling-plans-card rc-selling-plans.rc-custom-selling-plans-mounted {
      display: block !important;
    }
  `;

  root.appendChild(style);
}

function updateSellingPlansPosition() {
  const subscriptionCard = getSubscriptionCard();

  if (!subscriptionCard) {
    return;
  }

  const root = subscriptionCard.getRootNode();
  const parent = subscriptionCard.parentNode;

  if (!parent) {
    return;
  }

  ensureCustomSellingPlansStyles(root);

  let customCard = root.querySelector(".rc-custom-selling-plans-card");

  if (!customCard) {
    customCard = document.createElement("div");
    customCard.className = "rc-custom-selling-plans-card";
  }

  if (customCard.parentNode !== parent) {
    parent.insertBefore(customCard, subscriptionCard);
  } else if (customCard.nextSibling !== subscriptionCard) {
    parent.insertBefore(customCard, subscriptionCard);
  }

  const subscriptionSelected = isSubscriptionCardSelected(subscriptionCard);
  const sellingPlans = getSellingPlansElement(subscriptionCard, customCard);

  if (!sellingPlans) {
    customCard.hidden = !subscriptionSelected;
    return;
  }

  removeDuplicateSellingPlans(customCard, sellingPlans);

  /*
    Important:
    Mark it as mounted before/while moving it.
    Unmounted selectors are hidden by CSS.
  */
  sellingPlans.classList.add("rc-custom-selling-plans-mounted");

  if (sellingPlans.parentNode !== customCard) {
    customCard.appendChild(sellingPlans);
  }

  removeDuplicateSellingPlans(customCard, sellingPlans);

  const soldOut = isSelectedVariantSoldOut();

  // Sold-out variants must not show glow-cycle frequency options.
  customCard.hidden = !subscriptionSelected || soldOut;

  if (soldOut) {
    customCard.setAttribute("data-hidden-soldout", "true");
    selectOneTimePurchaseOption();
  } else {
    customCard.removeAttribute("data-hidden-soldout");
  }
}


function updateIntervalSelectorLabels() {
  const subscriptionCard = getSubscriptionCard();

  if (!subscriptionCard) {
    return;
  }

  const root = subscriptionCard.getRootNode();
  const customCard = root.querySelector(".rc-custom-selling-plans-card");
  const sellingPlans = getSellingPlansElement(subscriptionCard, customCard);

  if (!sellingPlans || !sellingPlans.shadowRoot) {
    return;
  }

  const labels = Array.from(
    sellingPlans.shadowRoot.querySelectorAll('label[part~="rc-plans-radio-button"]')
  );

  labels.forEach((label) => {
    const input = label.querySelector('input[type="radio"]');
    const intervalTextElement = label.querySelector(".rc-plans-button__interval");

    if (!intervalTextElement) {
      return;
    }

    const originalText = (
      input?.getAttribute("aria-label") ||
      intervalTextElement.dataset.originalIntervalText ||
      intervalTextElement.textContent ||
      ""
    ).trim();

    if (!intervalTextElement.dataset.originalIntervalText) {
      intervalTextElement.dataset.originalIntervalText = originalText;
    }

    const normalizedText = originalText.toLowerCase();

    if (normalizedText.includes("every 1 month")) {
      intervalTextElement.textContent = "Monthly";
    } else if (normalizedText.includes("every 2 month")) {
      intervalTextElement.textContent = "Every 2 Months";
    } else if (normalizedText.includes("every 3 month")) {
      intervalTextElement.textContent = "Every 3 Months";
    } else if (
      normalizedText.includes("every 4 month") ||
      normalizedText.includes("delivery every 4")
    ) {
      intervalTextElement.textContent = "Every 4 Months";
    }
  });
}

function applyPlansGridLayout() {
  const subscriptionCard = getSubscriptionCard();

  if (!subscriptionCard) {
    return;
  }

  const root = subscriptionCard.getRootNode();
  const customCard = root.querySelector(".rc-custom-selling-plans-card");
  const sellingPlans = getSellingPlansElement(subscriptionCard, customCard);

  if (!sellingPlans || !sellingPlans.shadowRoot) {
    return;
  }

  const sellingPlansRoot = sellingPlans.shadowRoot;
  ensurePopularBadgeStyles(sellingPlansRoot);

  const labels = Array.from(
    sellingPlansRoot.querySelectorAll('label[part~="rc-plans-radio-button"]')
  );

  if (!labels.length) {
    return;
  }

  const container = labels[0].parentElement;

  if (!container) {
    return;
  }

  if (labels.length === 4) {
    container.classList.add("rc-custom-plans-grid-2x2");
  } else {
    container.classList.remove("rc-custom-plans-grid-2x2");
  }
}

function applyPlansLabelPadding() {
  deepQueryAll('.rc-plans__label').forEach(function (label) {
    label.style.marginBottom = '12px';
  });
}

function renderRechargeCostPerDay() {
  observeOpenShadowRoots();

  syncSoldOutFrequencyVisibility();
  updateSellingPlansPosition();
  addPopularBadgeToTwoMonthButton();
  selectDefaultTwoMonthPlan();
  updateIntervalSelectorLabels();
  applyPlansGridLayout();
  applyPlansLabelPadding();

  // Re-apply after Recharge DOM moves, in case subscription was forced to one-time.
  syncSoldOutFrequencyVisibility();

  const subscriptionCard = getSubscriptionCard();

  if (!subscriptionCard) {
    return;
  }

  if (isSelectedVariantSoldOut()) {
    return;
  }

  const selectedPlanText = getSelectedPlanText(subscriptionCard);
  const intervalDays = parseIntervalDays(selectedPlanText);

  renderOneTimeCostPerDayComparison(intervalDays);

  const selectedSubscriptionCard = getSelectedSubscriptionCard();

  if (!selectedSubscriptionCard) {
    return;
  }

  const priceElement = selectedSubscriptionCard.querySelector(
    '[part~="rc-purchase-option__discounted-price"]'
  );

  if (!priceElement) {
    return;
  }

  const priceText = getVisibleText(priceElement);
  const price = parsePrice(priceText);

  if (price === null) {
    return;
  }

  const dailyPrice = price / intervalDays;
  const formattedDailyPrice = formatDailyPrice(dailyPrice);

  const costText = `${CONFIG.costLabelPrefix}${formattedDailyPrice}${CONFIG.costBoldSuffix}${CONFIG.costLabelSuffix}`;

  const benefitsList = getBenefitsList(selectedSubscriptionCard);

  if (!benefitsList) {
    return;
  }

  const benefitTexts = getBenefitTexts(benefitsList);

  if (!benefitTexts.length) {
    return;
  }

  renderCustomBenefitsRow(benefitsList, benefitTexts);

  renderCostPerDayRow(benefitsList, {
    fullText: costText,
    prefix: CONFIG.costLabelPrefix,
    price: formattedDailyPrice,
    boldSuffix: CONFIG.costBoldSuffix,
    suffix: CONFIG.costLabelSuffix,
  });
}

  function deepQueryAll(selector, root = document) {
    const results = [];

    function search(node) {
      if (!node) return;

      if (node.querySelectorAll) {
        results.push(...node.querySelectorAll(selector));
      }

      const children = node.querySelectorAll ? node.querySelectorAll("*") : [];

      children.forEach((child) => {
        if (child.shadowRoot) {
          search(child.shadowRoot);
        }
      });
    }

    search(root);
    return results;
  }

  function observeOpenShadowRoots(root = document) {
    const elements = root.querySelectorAll ? root.querySelectorAll("*") : [];

    elements.forEach((element) => {
      if (element.shadowRoot && !observedRoots.has(element.shadowRoot)) {
        observedRoots.add(element.shadowRoot);

        const observer = new MutationObserver(scheduleRender);
        observer.observe(element.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true,
        });

        observeOpenShadowRoots(element.shadowRoot);
      }
    });
  }

  function ensurePopularBadgeStyles(sellingPlansRoot) {
  if (sellingPlansRoot.querySelector("#rc-custom-popular-badge-styles")) {
    return;
  }

  const style = document.createElement("style");
  style.id = "rc-custom-popular-badge-styles";

  style.textContent = `
    label {
      overflow: visible;
    }

    .rc-plans-button {
      position: relative;
      overflow: visible;
      width: 100%;
      box-sizing: border-box;
    }

    .rc-custom-plans-grid-2x2 {
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      gap: 8px !important;
      align-items: stretch !important;
      overflow: visible !important;
    }

    .rc-custom-plans-grid-2x2 > label,
    .rc-custom-plans-grid-2x2 > [part~="rc-plans-radio-button"] {
      display: block !important;
      width: 100% !important;
      max-width: none !important;
      min-width: 0 !important;
      flex: none !important;
      margin: 0 !important;
      overflow: visible !important;
    }

    .rc-custom-plans-grid-2x2 .rc-plans-button {
      width: 100% !important;
    }

    .rc-plans-button:not(.rc-plans-button__selected):not([data-checked]) {
      background: #FFFFFF !important;
      border-style: solid !important;
      border-width: 1.5px !important;
      border-color: #CCCCCC !important;
      border-radius: 8px !important;
      padding: 10px 8px !important;
      box-sizing: border-box !important;
    }

    .rc-plans-button[data-checked],
    .rc-plans-button.rc-plans-button__selected {
      background: #324741 !important;
      border-style: solid !important;
      border-width: 1.5px !important;
      border-color: #324741 !important;
      border-radius: 8px !important;
      padding: 10px 8px !important;
      box-sizing: border-box !important;
      color: #FFFFFF !important;
    }

    .rc-plans-button__interval {
      font-family: 'Glacial Indifference', Arial, sans-serif !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      letter-spacing: 0 !important;
    }

    .rc-plans__label {
      display: block !important;
      width: 100% !important;
      margin: 0 0 12px !important;
      padding: 0 !important;
      font-family: 'Glacial Indifference Bold', 'Glacial Indifference', Arial, sans-serif !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      line-height: 20px !important;
      letter-spacing: 0 !important;
      color: #6C6660 !important;
      text-transform: none !important;
    }

    .rc-custom-popular-badge {
      position: absolute;
      top: -11.5px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 5;

      display: inline-flex;
      align-items: center;
      justify-content: center;

      padding: 2px 6px;
      border-radius: 10px;

      background: #E0BE7F;
      color: #000000;

      font-family: 'Glacial Indifference Bold', 'Glacial Indifference', Arial, sans-serif;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
      white-space: nowrap;
      pointer-events: none;
    }

  `;

  sellingPlansRoot.appendChild(style);
}

function addPopularBadgeToTwoMonthButton() {
  const subscriptionCard = getSubscriptionCard();

  if (!subscriptionCard) {
    return;
  }

  const root = subscriptionCard.getRootNode();
  const customCard = root.querySelector(".rc-custom-selling-plans-card");
  const sellingPlans = getSellingPlansElement(subscriptionCard, customCard);

  if (!sellingPlans || !sellingPlans.shadowRoot) {
    return;
  }

  const sellingPlansRoot = sellingPlans.shadowRoot;

  ensurePopularBadgeStyles(sellingPlansRoot);

  const planButtons = Array.from(
    sellingPlansRoot.querySelectorAll(".rc-plans-button")
  );

  const twoMonthButton = planButtons.find((button) => {
    const intervalText = button
      .querySelector(".rc-plans-button__interval")
      ?.textContent
      ?.trim()
      ?.toLowerCase();

    return intervalText && intervalText.includes("every 2 month");
  });

  if (!twoMonthButton) {
    return;
  }

  twoMonthButton.classList.add("rc-custom-popular-button");

  if (twoMonthButton.querySelector(".rc-custom-popular-badge")) {
    return;
  }

  const badge = document.createElement("span");
  badge.className = "rc-custom-popular-badge";
  badge.textContent = "Popular";

  twoMonthButton.appendChild(badge);
}

  function formatCurrencyValuesInConfig() {
    var config = window.SubscriptionWidgetConfig;
    if (!config || !config.formattedPrices || !config.shop) return;

    var currencyCode = String(getActiveCurrencyCode() || config.shop.currency).toUpperCase();

    function formatPrice(str) {
      if (typeof str !== "string") return str;

      var value = parsePrice(str, currencyCode);

      return value === null ? str : formatCurrency(value, currencyCode);
    }

    Object.keys(config.formattedPrices).forEach(function (variantId) {
      var v = config.formattedPrices[variantId];
      v.unit = formatPrice(v.unit);
      v.discounted = formatPrice(v.discounted);
      if (v.sellingPlans) {
        Object.keys(v.sellingPlans).forEach(function (planId) {
          v.sellingPlans[planId].price = formatPrice(v.sellingPlans[planId].price);
        });
      }
    });
  }

  formatCurrencyValuesInConfig();

  document.addEventListener("DOMContentLoaded", scheduleRender);
  document.addEventListener("change", scheduleRender, true);
  document.addEventListener("click", scheduleRender, true);

  // Theme Product section fires these when swatch/variant availability changes.
  document.addEventListener("variantUnavailable", function () {
    syncSoldOutFrequencyVisibility();
    scheduleRender();
  });
  document.addEventListener("variantAvailable", function () {
    syncSoldOutFrequencyVisibility();
    scheduleRender();
  });

  const documentObserver = new MutationObserver(scheduleRender);

  documentObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
  });

  scheduleRender();
})();